/* eslint-disable react-hooks/exhaustive-deps */
import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { findKeyBaseOnValue, housingProviderOption } from '../../ModificationsUtils';

export const HousingProvider = () => {
  const { control, getValues, register, setValue, clearErrors, setError } = useFormContext();
  const { t } = useTranslation();
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const isModEdit = useSelector(selectIsEditMod);
  const housingProvider = 'housingProvider';
  register('housingProviderId');

  const getId = (value: string) => {
    const selectedOption = findKeyBaseOnValue(housingProviderOption, value);
    return selectedOption.Id;
  };

  const onSelectionChange = (value?: string) => {
    setValue(housingProvider, value);
    setValue('housingProviderId', getId(value));
    
    // Clear dependent fields when housing provider changes and set error
    setValue('travelerRequestedHousingType', '');
    setError('travelerRequestedHousingType', {});

    setValue('actualHousingType', '');
    setError('actualHousingType', {});
    
    if (value) {
      clearErrors(housingProvider);
    } else {
      setError(housingProvider, {});
    }
  };

  useEffect(() => {
    if (getValues(housingProvider)) {
      setValue('housingProviderId', getId(getValues(housingProvider)));
      clearErrors(housingProvider);
    } else {
      setError(housingProvider, {});
    }
  }, []);

  return (
    <Controller
      control={control}
      name={housingProvider}
      rules={{
        required: true,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <FormInputDropdown
          useMenuItem={true}
          name={housingProvider}
          label={t('placement.placementMods.housingProvider')}
          standard={true}
          options={housingProviderOption ?? []}
          handleChange={e => {
            onSelectionChange(e.target.value);
            onChange(e.target.value);
          }}
          inputValue={getValues(housingProvider) ?? ''}
          readOnly={!isModEdit}
          disabled={isSaveModApiCalling}
          {...rest}
        ></FormInputDropdown>
      )}
    />
  );
};
